import * as React from 'react';
import { IMicrositeRecipientForListWithSelect } from './models/microsite-recipient-for-list-with-select';
import { MicrositeListType } from '@nkr/enums/index';
import { AdminGridWrapper } from '../styles';
import CommonList from './common-list';
import { GridReadyEvent } from 'ag-grid-community';

interface IProps {
    centerId: number,
    listType: MicrositeListType,
    list: IMicrositeRecipientForListWithSelect[],
    isLoading: boolean,
    onSelectAllRows: () => void,
    onRowSelected: (id: number, isSelected: boolean) => void,
    onSendReminderEmail: (id: number) => void,
    onShowLinkedEntities: (id: number) => void,
    onGetDonorRegistrationForMSPatients: (id: number) => void,
    onResendApprovalEmail: (id: number) => void,
    onDownloadBatchFile: (id: number) => void,
    onLoadingComplete: () => void,
    onGridReady: (e: GridReadyEvent) => void,
    onChangeStatus: (id: number) => void
}

const AdminMicrositeList = (props: IProps) => {
    return (
        <AdminGridWrapper className='ag-theme-bootstrap'>
            <CommonList
                list={props.list}
                listType={props.listType}
                centerId={props.centerId}
                isAdmin={true}
                isAdminLogin={true}
                isLoading={props.isLoading}
                onSelectAllRows={props.onSelectAllRows}
                onRowSelected={props.onRowSelected}
                onSendReminderEmail={props.onSendReminderEmail}
                onGetDonorRegistrationForMSPatients={props.onGetDonorRegistrationForMSPatients}
                onResendApprovalEmail={props.onResendApprovalEmail}
                onDownloadBatchFile={props.onDownloadBatchFile}
                onLoadingComplete={props.onLoadingComplete}
                onGridReady={props.onGridReady} 
                onShowLinkedEntities={props.onShowLinkedEntities} 
                onChangeStatus={props.onChangeStatus}
            />
        </AdminGridWrapper>
    );
}

export default AdminMicrositeList;